import React from "react";
import {
  getChangeAdminGuidance,
  isOpenTicketChange,
} from "../../../../data/flight/order/getChangeAdminGuidance";

/**
 * Task 10 — settlement vs supplier success stay separate.
 */
export default function ChangeSettlementBanner({ data }) {
  if (!data || isOpenTicketChange(data)) return null;
  const guidance = getChangeAdminGuidance(data);
  const stage = guidance.stage;

  if (
    !["settlement_failed", "failure_settling", "failure_settled", "needs_reissue"].includes(
      stage,
    )
  ) {
    return null;
  }

  const copy = {
    settlement_failed: {
      title: "Ticket change may be done — wallet settlement failed",
      text: "Supplier/airline success is separate from money. Do not reverse a successful ticket change. Finance attention is required for release or fix.",
      tone: "bg-red-50 border-red-200 text-red-900",
    },
    failure_settling: {
      title: "Funds need release / reversal",
      text: "The airline did not complete this change. Finance is releasing or reversing reserved payment. Keep this as a failed change, not completed.",
      tone: "bg-amber-50 border-amber-200 text-amber-950",
    },
    failure_settled: {
      title: "Failure settled",
      text: "Money side is settled for a failed change. Original ticket state is preserved.",
      tone: "bg-gray-50 border-gray-200 text-gray-800",
    },
    needs_reissue: {
      title: "Write ticket — check settlement separately",
      text:
        data?.status && /settlement/i.test(String(data.status))
          ? "Confirm re-issue only if the airline already issued the new ticket. Check settlement status separately from supplier success."
          : "Confirm re-issue only if the airline already issued the new ticket. Wallet settlement is a separate status.",
      tone: "bg-blue-50 border-blue-200 text-blue-950",
    },
  }[stage];

  if (!copy) return null;

  return (
    <div className={`w-full rounded-xl border px-4 py-3 mt-4 ${copy.tone}`}>
      <div className="text-sm font-semibold">{copy.title}</div>
      <p className="text-xs mt-1 leading-relaxed">{copy.text}</p>
      {data?.settlementStatus ? (
        <div className="text-[11px] mt-2 font-medium">
          Settlement status: {data.settlementStatus}
        </div>
      ) : null}
      {guidance.statusLabel ? (
        <div className="text-[11px] mt-1 opacity-80">
          Request status: {guidance.statusLabel}
        </div>
      ) : null}
    </div>
  );
}
